/** 유저의 로그인 정보를 다루는 유틸 함수 모음 */
import utils from '@/common/util/utils'
import { getSessionStorage, getStorage } from '@/common/util/storage.util'
import {
  URL_COOKIE_DOMAIN,
  COOKIE_KEY_VERIFIED_ADULT,
  CONFIRM_EMERGENCY,
} from '@/common/constant'
import { forIn } from 'lodash'
import store from '@/store'
import { useConsentRenew } from '@/common/use/useConsentRenew'

const { storage } = useConsentRenew()

/**
 * 유저 로그아웃 처리를 위해 클라이언트에서 수행하는 로직 (api 호출 제외)
 * - 쿠키에서 유저 정보 삭제
 * - 세션스토리지, 로컬스토리지 정보 삭제
 */
export const clearStorageForLogout = () => {
  utils.cookies.removeItem('cs', URL_COOKIE_DOMAIN, '/')
  utils.cookies.removeItem('credential', URL_COOKIE_DOMAIN, '/')
  utils.cookies.removeItem(COOKIE_KEY_VERIFIED_ADULT, URL_COOKIE_DOMAIN, '/')
  utils.cookies.removeItem('app-credential', URL_COOKIE_DOMAIN, '/')
  utils.cookies.removeAdultContentSettingsValue()
  storage.removeSessionConsentCheck()
  getStorage().clearExceptKeys(['guid', 'wavve-device-id'])
  getSessionStorage().clear()
  forIn(sessionStorage, (_, key) => {
    if (key !== CONFIRM_EMERGENCY) {
      sessionStorage.removeItem(key)
    }
  })
}

/**
 * 쿠키 내 크리덴셜 관련 정보를 업데이트한다 (cs의 credential값, credential)
 * @param {string} credential 변경할 새로운 credential 값
 * @param {boolean} options.isSetStore store의 csInfo도 업데이트 할지 여부(default: true)
 */
export const updateCredentialInCookie = (credential, options = {}) => {
  const { isSetStore = true } = options
  if (!credential) return
  if (utils.cookies.getAutoLoginCredential()) {
    utils.cookies.setAutoLoginCredential(credential)
  }
  const csInfo = utils.cookies.userInfo()
  csInfo.credential = credential
  utils.cookies.setItem(
    'cs',
    JSON.stringify(csInfo),
    null,
    URL_COOKIE_DOMAIN,
    '/',
  )
  isSetStore &&
    store.commit('setCsInfo', JSON.parse(utils.cookies.getItem('cs')))
}
